import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Wind(props) {
    return (
        <SvgIcon viewBox="0 0 56 56" {...props} >
            <circle cx="28" cy="28" r="28" fill="white"/>
            <circle cx="24.889" cy="18.6667" r="5.22222" fill="white" stroke="black" stroke-width="2"/>
            <circle cx="39.2222" cy="22.7822" r="5.22222" fill="white" stroke="black" stroke-width="2"/>
            <circle cx="31.1111" cy="37.3333" r="5.22222" fill="white" stroke="black" stroke-width="2"/>
            <path d="M31.1111 32.1111H12.9998" stroke="black" stroke-width="2"/>
            <path d="M39 28L13 28" stroke="black" stroke-width="2"/>
            <path d="M25.4443 23.88L12.9999 23.88" stroke="black" stroke-width="2"/>
        </SvgIcon>
    );
}